<dialog-draggable-header>Supersede Part</dialog-draggable-header>

<mat-card class="ecm-parts-supersede-selector">
  <mat-radio-group [(ngModel)]="newPart" aria-label="Is this a">
    Is this a
    <mat-radio-button [checked]="true" [value]="true">New Part</mat-radio-button>
    <mat-radio-button [value]="false">Existing part</mat-radio-button>
  </mat-radio-group>
</mat-card>
<mat-card>
  <div *ngIf="newPart;else notNewPart">
    <form [formGroup]="partSupersedeForm">
      <div class="ecm-parts-supersede-label">
        <mat-label>Enter the new part number to use to supersede {{this.part?.partNumber}}:</mat-label>
      </div>
      <mat-form-field>
        <input id="new-part-number" matInput type="text" placeholder="New Part Number" formControlName="newPartNumber"
          #newPartNumber />
        <mat-error *ngIf="partSupersedeForm.controls.newPartNumber.hasError('required')">Required</mat-error>
        <mat-error *ngIf="newPartNumber.value?.length > 8 || newPartNumber.value?.length < 0">Part number must be
          greater than 0 and less than or equal to 8</mat-error>
      </mat-form-field>
      <div class="ecm-parts-supersede-label">
        <mat-label>Enter the Opposite Part Number, if applicable:</mat-label>
      </div>
      <mat-form-field>
        <input #oppositePartNumber id="opposite-part-number" matInput type="text" placeholder="Opposite Part Number"
          formControlName="oppositePartNumber" />
        <mat-error *ngIf="oppositePartNumber.value?.length > 8">Field cannot be
          more than 8 characters</mat-error>

      </mat-form-field>
    </form>
  </div>
  <ng-template #notNewPart>
    <searchable-autocomplete [options]="parts" filterBy="fullPartDesc" [(selected)]="this.selectedPart">
    </searchable-autocomplete>
  </ng-template>
</mat-card>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" (keypress.enter)="save()" (click)="save()"
    [disabled]="!hasEnabledFields">Save</button>
  <button mat-raised-button (keypress.enter)="close()" (click)="close()">Cancel</button>

</mat-dialog-actions>